import { render, staticRenderFns } from "./updateImg.vue?vue&type=template&id=16915d4a"
import script from "./updateImg.vue?vue&type=script&lang=js"
export * from "./updateImg.vue?vue&type=script&lang=js"
import style0 from "./updateImg.vue?vue&type=style&index=0&id=16915d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports